import i18n from '../../../../i18n'
import Block1 from './Blocks/Block1'
import Block2 from './Blocks/Block2'
import Block3 from './Blocks/Block3'
import Block5 from './Blocks/Block5'
import Block6 from './Blocks/Block6'
import FlipCards from './Blocks/FlipCards'
import MemoryCards from './Blocks/MemoryCards'
import ThenNow from './Blocks/ThenNow'
import TimelineBlock from './Blocks/TimelineBlock'
import TriviaQuiz from './Blocks/TriviaQuiz'
import InteractiveImage from './Blocks/InteractiveImage'
import HiddenObjects from './Blocks/HiddenObjects'
import LeadForm from './Blocks/LeadForm'
import FindPair from './Blocks/FindPair'
import Slideshow from './Blocks/Slideshow'
import CardBlock from './Blocks/CardBlock'
import PersonalityQuiz from './Blocks/PersonalityQuiz'
import PuzzleBlock from './Blocks/PuzzleBlock'
import { MODAL_NAMES } from './Modals/ModalController.jsx'

import BLOCK from '../../../../common/constants/BlockTypes/BlocksEnum'

export const PROJECT_DATA_TYPES = {
    app: 'app',
    blocks: 'blocks',
    pages: 'pages',
}

export const SUPPORTED_REMIX_BLOCKS = [
    BLOCK.text,
    BLOCK.image,
    BLOCK.embedInteractyProject,
    BLOCK.flipCards,
    BLOCK.youtubeVideo,
    BLOCK.button,
    BLOCK.interactiveImage,
    BLOCK.hiddenObjects,
    BLOCK.quiz,
    BLOCK.thenNow,
    BLOCK.memoryCards,
    BLOCK.timeline,
    BLOCK.cookies,
    BLOCK.horoscope,
    BLOCK.personalityQuiz,
    BLOCK.leadForm,
    BLOCK.findPair,
    BLOCK.slideshow,
    BLOCK.puzzle,
]

export const BlockComponents = {
    [BLOCK.text]: Block1,
    [BLOCK.image]: Block2,
    [BLOCK.embedInteractyProject]: Block3,
    [BLOCK.flipCards]: FlipCards,
    [BLOCK.youtubeVideo]: Block5,
    [BLOCK.button]: Block6,
    [BLOCK.interactiveImage]: InteractiveImage,
    [BLOCK.hiddenObjects]: HiddenObjects,
    [BLOCK.quiz]: TriviaQuiz,
    [BLOCK.thenNow]: ThenNow,
    [BLOCK.memoryCards]: MemoryCards,
    [BLOCK.timeline]: TimelineBlock,
    [BLOCK.cookies]: CardBlock,
    [BLOCK.horoscope]: CardBlock,
    [BLOCK.personalityQuiz]: PersonalityQuiz,
    [BLOCK.leadForm]: LeadForm,
    [BLOCK.findPair]: FindPair,
    [BLOCK.slideshow]: Slideshow,
    [BLOCK.puzzle]: PuzzleBlock,
}

export const APP_SCHEME = {
    maxWidth: {
        label: i18n.t('Max width'),
        type: 'number',
        default: 800,
        min: 320,
        max: 4320, // 8k
        control: 'TextInput',
        payload: {
            controlType: 'number',
        },
    },
    bg: {
        label: i18n.t('Background color'),
        type: 'string',
        default: '#fff',
        control: 'ColorPicker',
    },
    customTranslations: {
        label: i18n.t('Custom translations'),
        type: 'string',
        default: '',
        control: 'LinkWithModal',
        payload: {
            modalName: MODAL_NAMES.customTranslationsModal,
        },
    },
    customStyles: {
        label: 'Custom styles',
        type: 'string',
        default: '',
        control: 'TextArea',
    },
}
